module.exports = __webpack_public_path__ + "img/new_zhututubiao.3091bbd4.png";